import { useEffect } from "react";

export function useFavicon(url: string | null | undefined): void {
  useEffect(() => {
    if (!url) return;
    const link = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
    if (!link) return;
    const previousHref = link.href;
    const previousType = link.type;
    link.href = url;
    link.removeAttribute("type");
    return () => {
      link.href = previousHref;
      if (previousType) link.type = previousType;
    };
  }, [url]);
}
